import React, { Component } from 'react';
import DailyNewsService from '../../../services/daily-news';

class BEArticlesSummary extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isError: false
    };

    this.getSummary(props);
  }

  componentDidUpdate(props) {
    // this.getSummary(props);
  }

  getSummary(props) {
    const queryStringStr = props.location.search.substring(4);
    const parts = queryStringStr.split('&');
    const sinceId = parts[0];
    const format = parts[1] && parts[1].substring('format='.length);

    DailyNewsService.getSummarySinceId(sinceId, format)
      .then((summary) => {
        this.setState({ 
          summary: (summary && summary.data) || 'no data'
        });
      })
      .catch((err) => {
        const errorMessage = err && err.response && err.response.data;
        this.setState({ isError: true, errorMessage: errorMessage });
      });
  }

  render() {
    let body = 'Processing...';
    if (this.state && this.state.summary) {
      body = (
        <p>
          { this.state.summary }
        </p>
      );
    }

    if (this.state.isError) {
      body = 'Error';
      body += this.state.errorMessage ? `: ${this.state.errorMessage}` : '';
    }

    return (
      <section className='regular-page'>
        {body}
      </section>
    );
  }
}

export default BEArticlesSummary;
